

























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { MemberAccountListCard } from '@/@types/Member.js';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountIcon,
  },
})
export default class AccountListTable extends Vue {
  @Prop({ type: Array }) public accountList!: Array<MemberAccountListCard>;
  private isFavorite: boolean = false;
  private ishover: boolean = false;

  private makeFavorite(): void {
    this.isFavorite = !this.isFavorite;
  }
  private starColor(): 'yellow darken-1' | '#bdbdbd' {
    if (this.isFavorite) {
      return 'yellow darken-1';
    }
    return '#bdbdbd';
  }
}
